export default {
  "HELLO": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Halo"])},
  "Account": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pengaturan Pengguna"])},
  "List with us": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Daftarkan dengan kami"])},
  "user": {
    "upcoming": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pemesanan yang Akan Datang"])},
    "become": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Menjadi Tuan Rumah"])}
  },
  "host": {
    "New Orders": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pesanan Baru"])},
    "Booking Calendar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kalender Pemesanan"])}
  }
}